import styled from 'styled-components'

export const Container = styled.section`
  position: relative;
  height: 100%;
`

export const Header = styled.header`
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  @media (max-width: 1096px) {
    margin-bottom: 25px;
  }
  
`

export const EmptyReviews = styled.div`
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  
`